function togglePromoFilter() {
  let button = $('.promo__button');
  let list = $('.promo__list');
  let background = $('.promo__filter-bg');
  
  button.on('click', function (e) {
    e.stopPropagation();
    list.toggleClass('active');
    background.toggleClass('active');
  });
  
  $(document).on('mouseup', function(e) {
    if (!list.is(e.target) && !button.is(e.target) && list.has(e.target).length === 0 && button.has(e.target).length === 0) {
      list.removeClass('active');
      background.removeClass('active');
    }
  });

  list.on('submit', function() {
    list.removeClass('active');
    background.removeClass('active');
  });
}

togglePromoFilter();
